import React from 'react'
import './TodoHeader.css'

function TodoHeader({
    time,
    note,
    extra2Text,
    extra3Links,
    inputMethod,
    noteIsPublic = true,
    onNoteVisibilityChange,
    showNoteVisibility = true,
}) {
    // 解析链接字符串：每行格式为 "链接文本|链接地址" 或直接是链接地址
    const parseLinks = (linksStr) => {
        if (!linksStr || !linksStr.trim()) {
            return []
        }
        return linksStr.split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0)
            .map(line => {
                // 支持两种格式：1. "文本|链接"  2. 直接是链接
                const parts = line.split('|')
                if (parts.length >= 2) {
                    return {
                        text: parts[0].trim(),
                        url: parts.slice(1).join('|').trim()
                    }
                } else {
                    const urlMatch = line.match(/https?:\/\/[^\s]+/)
                    if (urlMatch) {
                        return {
                            text: line.replace(urlMatch[0], '').trim() || urlMatch[0],
                            url: urlMatch[0]
                        }
                    }
                    return null
                }
            })
            .filter(link => link && link.url && (link.url.startsWith('http://') || link.url.startsWith('https://')))
    }

    const links = parseLinks(extra3Links)

    return (
        <div>
            <div className="container-header">
                <div>
                    <span id="today">{time} 时间消费记录</span>
                </div>
            </div>
            <div className="container-limit">
                {extra2Text && <pre>{extra2Text}</pre>}
                {links.map((link, index) => (
                    <span key={index}>
                        <a href={link.url} rel="noreferrer" target="_blank">{link.text}</a>
                    </span>
                ))}
            </div>

            <div className="container-todo-title">
                <p>今日聚焦</p>
                {showNoteVisibility && (
                    <label className="note-visibility" title="关闭后，备注不会出现在你的公开主页">
                        <span className="note-visibility-text">
                            {noteIsPublic ? '公开' : '仅自见'}
                        </span>
                        <span className={`note-switch${noteIsPublic ? ' is-on' : ''}`}>
                            <input
                                type="checkbox"
                                checked={noteIsPublic}
                                disabled={!onNoteVisibilityChange}
                                aria-label="备注是否公开"
                                onChange={(e) => onNoteVisibilityChange?.(e.target.checked)}
                            />
                            <span className="note-switch-handle" />
                        </span>
                    </label>
                )}
            </div>
            <pre className="container-todo" onInput={inputMethod} suppressContentEditableWarning={true} contentEditable="plaintext-only">
                <div className="container-todo-content">{note}</div>
            </pre>
        </div>
    )
}


export default TodoHeader